import React from 'react';
import { FC } from 'react';

export const CheckNegativeSolid: FC<{ className?: string }> = () => (
    <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect y='0.5' width='20' height='20' rx='10' />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M8.31476 14.358L5.13295 10.941C4.95568 10.753 4.95568 10.447 5.13295 10.257L5.77568 9.574C5.95295 9.386 6.24113 9.386 6.4184 9.574L8.63657 11.966L13.5811 6.641C13.7584 6.453 14.0465 6.453 14.2238 6.641L14.8665 7.325C15.0438 7.513 15.0438 7.82 14.8665 8.007L8.95748 14.358C8.78021 14.546 8.49203 14.546 8.31476 14.358Z'
            fill='white'
        />
    </svg>
);
